<template>
    <div class="container-fluid"><slot /></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({ name: 'CContainer' });
</script>
